<template>
  <div class="guideBox transfer">
    <el-col :span="16">
      <div class="flex">
        <div class="title">
          人员
        </div>
        <div
          class="flex allSet set"
          @click.stop="setItem('all', isAllSetType)"
        >
          <div :class="{ 'isSet': !isAllSetType, 'allSet_BtnBox': true }">
            <i
              v-if="!isAllSetType && list.length"
              class="el-icon-check"
            />
          </div>
          <div class="allSet_txt">
            选择部门所有人员
          </div>
        </div>
      </div>
      <div class="left_box">
        <div class="flex" />
        <div>
          <div
            v-for="(item, index) in list"
            :key="item.userid + index"
            class="items set"
            @click="setItem('item', item.isSet, index)"
          >
            <i
              v-if="!item.salesperson_avatar"
              style="line-height: 22px"
              class="el-icon-user"
            />
            <img
              v-else
              :src="item.salesperson_avatar"
              class="items_avatar"
              alt=""
            >
            <span>{{ item.name }}</span>
            <span class="items_set">{{ item.isSet ? '已选' : '    ' }}</span>
          </div>
          <div
            v-show="list.length == 0"
            class="notList"
          >
            当前组织下没有成员
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="16">
      <div class="flex">
        <div class="title">
          已选导购
        </div>
        <div
          class="allSet set"
          style="line-height: 22px; color: #409eff"
          @click="unSetItem"
        >
          取消全选
        </div>
      </div>
      <div class="right_box">
        <div>
          <div
            v-for="(item, index) in isList"
            :key="item.userid"
            class="items"
          >
            <i
              v-if="!item.salesperson_avatar"
              style="line-height: 22px"
              class="el-icon-user"
            />
            <img
              v-else
              :src="item.salesperson_avatar"
              class="items_avatar"
              alt=""
            >
            <span>{{ item.name }}</span>
            <span
              class="items_set"
              @click="setItem('del', false, index)"
            >{{
              item.isSet ? '删除' : ''
            }}</span>
          </div>
          <div
            v-for="(item, index) in isNodes"
            :key="item.id"
            class="items"
          >
            <i
              style="line-height: 22px"
              class="el-icon-folder-opened"
            />
            <!-- <span>icon</span> -->
            <span class="items_name">{{ item.name }}</span>
            <!-- <span>人数：{{ item.total_count }}</span> -->
            <span
              class="items_set"
              @click="setItem('del', false, index, 'node')"
            >删除</span>
          </div>
          <div
            v-show="Object.keys(isNodes).length == 0 && Object.keys(isList).length == 0"
            class="notList"
          >
            当前未选择
          </div>
        </div>
      </div>
    </el-col>
  </div>
</template>

<script>
export default {
  props: {
    //穿梭框所需要的数据
    userList: {
      type: Array,
      default: function () {
        return []
      }
    },
    callUserList: {
      type: Array,
      default: () => {
        return []
      }
    },
    callStoreList: {
      type: Array,
      default: () => {
        return []
      }
    },
    //当前参与的节点
    gNode: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isFSet: {
      type: Array,
      default: function () {
        return []
      }
    }
  },

  data () {
    return {
      box: false,
      list: [],
      isList: {}, //当前选中项
      isNodes: {}, //当前打进的
      isAllSetType: true, //是否全选
      gNodeDataTotal_count: 0,
      gNodeSum: 0
    }
  },
  computed: {},
  watch: {
    userList (nv) {
      // console.log('userList-change', nv)
      this.list = JSON.parse(JSON.stringify(nv))
      this.depList()
    },
    isList (nv, ov) {},
    gNode (nv) {
      // console.log('transfer-gNode-change',nv)
      if (this.gNode.total_count) {
        this.gNodeDataTotal_count += this.gNode.total_count || 0
        this.gNodeDataTotal_count--
      }
      nv && this.insetGNode(nv)
      // this.$set(this.isNodes, nv.id, nv)
      // this.setOnly(nv.id)
    },
    callUserList (nv) {
      this.showCallData(nv)
    }
  },
  created () {},
  mounted () {
    this.showCallData(this.callUserList)
    this.insetGNode(this.callStoreList)
  },
  methods: {
    //外部注入gnode
    insetGNode (node) {
      // console.log('insetGNode', node)
      if (!node) return
      if (node.length) {
        for (let i of node) {
          this.$set(this.isNodes, i.id, i)
        }
      }
      if (node.id) this.$set(this.isNodes, node.id, node)
    },
    //回显用户数据
    showCallData (userList) {
      // console.log('showCallData-userList', userList)
      // if(!callData||!callData.length)return
      userList &&
        userList.length &&
        userList.forEach((d) => {
          d.isSet = true
          this.$set(this.isList, d.userid, d)
        })
      // console.log('回显用户数据-showCallData', this.isList, this.isNodes)
    },
    //去重
    setOnly (id) {
      for (let i in this.isList) {
        // console.log('this.isList[i]', { ...this.isList[i] }, id)
        if (this.isList[i].fid == id) delete this.isList[i]
      }
    },
    //取消全选
    unSetItem () {
      let { isList, isNodes } = this
      // console.log('取消全选-unSetItem', isList, isNodes)
      for (let i in isList) {
        this.setItem('del', false, i)
      }
      for (let i in isNodes) {
        this.setItem('del', false, i, 'node')
      }
    },
    //修改选中器
    setItem (type, bool, index, itemType = 'user') {
      // console.log('setItem-type, bool, index', type, bool, index)
      switch (type) {
        case 'all':
          this.$set(
            this,
            'list',
            this.list.map((d) => {
              d.isSet = bool
              return d
            })
          )
          break
        case 'item':
          this.$set(this.list[index], 'isSet', !bool)
          break
        case 'del':
          {
            //判断当前是否为 node
            if (itemType == 'node') {
              this.gNodeDataTotal_count -= this.isNodes[index].total_count
              console.log('this.gNodeDataTotal_count', this.gNodeDataTotal_count)
              this.$emit('backNode', this.isNodes[index])
              delete this.isNodes[index]
            } else {
              this.list.forEach((d, idx) => {
                d.userid == index && this.$set(this.list[idx], 'isSet', bool)
              })
              // if (this.isList[index].parentid) {
              //   //判断当前是否为 node
              //   this.gNodeDataTotal_count -= this.isList[index].total_count
              //   console.log('this.gNodeDataTotal_count', this.gNodeDataTotal_count)
              //   this.$emit('backNode', this.isList[index])
              // }
              delete this.isList[index]
            }
          }
          break
      }

      this.changeSetItem()
      this.wathchList()
    },
    //改变全选状态
    changeSetItem () {
      let sun = 0
      this.list.forEach((d) => {
        d.isSet && sun++
      })
      this.isAllSetType = sun != this.list.length ? true : false
    },
    //检测当前list 的change 、然后将 当前list的选中状态 同步到 islist
    wathchList () {
      let isList = JSON.parse(JSON.stringify(this.isList)),
        list = JSON.parse(JSON.stringify(this.list))
      // console.log('wathchList-list',list)
      // 对 islist 进行 更新
      list.forEach((d) => {
        d.isSet && !isList[d.userid] && (isList[d.userid] = d)
        isList[d.userid] && !d.isSet && delete isList[d.userid]
      })
      this.isList = isList
    },
    //每次List更新，去回显之前set过的数据
    depList () {
      this.$set(
        this,
        'list',
        this.list.map((d, idx) => {
          d.isSet = this.isList[d.userid] ? true : false
          return d
        })
      )
      this.changeSetItem()
    },
    getUserList () {
      return {
        userList: Object.values(this.isList),
        storeList: Object.values(this.isNodes)
      }
    }
  }
}
</script>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss" scoped>
.set {
  cursor: pointer;
}
.transfer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .allSet {
    // color: #409EFF;
    &_BtnBox {
      border: 1px solid #409eff;
      width: 17px;
      height: 17px;
      line-height: 17px;
      border-radius: 3px;
    }
    &_txt {
      margin-left: 10px;
    }
  }
  .notList {
    text-align: center;
    margin-top: 10px;
    color: #9999;
  }

  .left_box {
    border-right: 1px solid #dcdfe6;
    border-left: 1px solid #dcdfe6;
    height: 100%;
    padding: 10px 20px;
    height: 420px;
    overflow: auto;

    .isSet {
      background: #409eff;
      color: #fff;
    }
  }
  .items {
    display: flex;
    justify-content: space-between;
    padding: 2px 5px;
    line-height: 22px;
    &_set {
      color: #409eff;
      cursor: pointer;
    }
    &_avatar {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
    &_name {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100px;
    }
  }
  .items:hover {
    background: #f0f7ff;
  }
  .right_box {
    padding: 10px 20px;
    height: 100%;
    height: 420px;
    overflow: auto;
  }
}
</style>
